import { render, staticRenderFns } from "./settings-panel.vue?vue&type=template&id=2927f841&scoped=true&"
import script from "./settings-panel.vue?vue&type=script&lang=ts&"
export * from "./settings-panel.vue?vue&type=script&lang=ts&"
import style0 from "./settings-panel.vue?vue&type=style&index=0&id=2927f841&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2927f841",
  null
  
)

export default component.exports